import { api } from '@/services'
export function fetchEnabledCitiesAdmin () {
  return api.get('/admin/city/listEnabled')
}
export function fetchCities (params) {
  return api.get('/web/city', { params: params })
}

export function find(id) {
  return api.get(`/admin/city/findById/${id}`)
}

export function fetchRealEstateCity() {
  return api.get(`/web/city/getRealEstateCity`)
}

export function fetchCitiesByRealties() {
  return api.get(`/web/realty/listRealtyCities`)
}

export function fetchCitiesPaginated(params) {
  const isRealEstate = localStorage.getItem('user_type').includes('ROLE_REAL_ESTATE')
  var url = isRealEstate ? '/web/city/listPaginated' : '/admin/city/list'
  return api.get(url, { params: params })
}

export function updateStatus(id) {
  return api.post(`/admin/city/updateStatus/${id}`)
}

export function updateServices(body) {
  return api.post('/admin/city/updateServices', body)
}

export function fetchCitiesAsAdmin() {
  return api.get('/admin/city/listEnabled')
}
